@if (urlMarketing() && marketingBanner()) {
  <a class="marketing-link gs1-spacing-2xl" target="_blank" rel="noopener" (click)="naviagteToBannerUrl()">
    <img [src]="marketingBanner().base64" alt="banner" />
  </a>
} @else {
  <div class="spinner">
    <div gs1Spinner [big]="true" [size]="'80px'"></div>
  </div>
}
